export default "__VITE_PUBLIC_ASSET__fdfb1f80__"